import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NotificationType } from '@core/enums/notification-type.enum';
import { NotificationService } from '@core/services/notification.service';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'va-notification-toast',
    template: `<p-toast></p-toast>`,
    styles: [
        `
      :host ::ng-deep .p-toast {
        position: fixed;
        width: auto !important;
      }
    `,
    ],
    standalone: true,
    imports: [ToastModule],
})
export class NotificationComponent implements OnInit, OnDestroy {
  private notificationService = inject(NotificationService);
  private notification = inject(MessageService);

  subscription?: Subscription;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit(): void {
    this.subscription = this.notificationService.listenNotificationToastr().subscribe((notification) => {
      this.openNotification(notification);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openNotification(notification: ToastMessageOptions): void {
    switch (notification.severity) {
      case NotificationType.INFO:
        this.notification.add(notification);
        break;

      case NotificationType.SUCCESS:
        this.notification.add(notification);
        break;

      case NotificationType.WARNING:
        this.notification.add(notification);
        break;

      case NotificationType.ERROR:
        this.notification.add(notification);
        break;
    }
  }
}
